import PropTypes from 'prop-types';
import React from 'react';

const Separate = ({items}) => {
  let formatted = items.filter(function (item, index) {
    return item[1] && item[1] !== '0';
  }).map(function (item, index) {
    return item[0] + ': ' + item[1] + (item[2] ? ' ' + item[2] : '');
  });
  var separated = formatted.join(' | ');
  return (
    <p className="info-2">
      {separated}
    </p>
  );
}

Separate.propTypes = {
  items: PropTypes.array.isRequired
};

export default Separate;


// WEBPACK FOOTER //
// ./src/components/search/result/separate.jsx